import { motion } from 'motion/react';
import { forwardRef } from 'react';

type Props = {
  className?: string;
};

const VPiece = forwardRef<HTMLDivElement, Props>(({ className }, ref) => {
  return (
    <div ref={ref} className={className}>
      <svg
        width='142'
        height='136'
        viewBox='0 0 142 136'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path d='M67.1327 130.943L1.52195 12.0999C-1.42166 6.76805 2.43507 0.233398 8.52553 0.233398H133.66C139.609 0.233398 143.477 6.49648 140.813 11.816L81.2892 130.659C78.405 136.418 70.2455 136.581 67.1327 130.943Z' />
      </svg>
    </div>
  );
});

VPiece.displayName = 'VPiece';

export default motion.create(VPiece);
